<div id="ChartLibContainer" class="anytype-stacked-column-chart" style="height:{{chartHeight}}px;"></div>